import { render } from "./PlayerBar.vue?vue&type=template&id=91d7b31e&scoped=true"
import script from "./PlayerBar.vue?vue&type=script&lang=js"
export * from "./PlayerBar.vue?vue&type=script&lang=js"

import "./PlayerBar.vue?vue&type=style&index=0&id=91d7b31e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-91d7b31e"]])

export default __exports__